import { createSignal } from 'solid-js';
import { isServer } from 'solid-js/web';

const [hasMountedGTM, setHasMountedGTM] = createSignal(false);

export function insertGtmScript(id: string, cookieYesId?: string) {
	if (hasMountedGTM() || isServer) {
		return;
	}

	window.dataLayer = window.dataLayer || [];
	// See note about Arguments object. We still want to type the function, so this is here for that
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	function gtag(...args: Array<unknown>) {
		// The dataLayer specifically looks for an Arguments object
		// eslint-disable-next-line prefer-rest-params
		window.dataLayer.push(arguments);
	}

	if (cookieYesId) {
		// Default consent is denied. CookieYes will trigger consent granting on its own
		gtag('consent', 'default', {
			ad_storage: 'denied',
			ad_user_data: 'denied',
			ad_personalization: 'denied',
			analytics_storage: 'denied',
			functionality_storage: 'denied',
			personalization_storage: 'denied',
			security_storage: 'granted',
			wait_for_update: 5000,
		});
		gtag('set', 'ads_data_redaction', true);
		gtag('set', 'url_passthrough', true);
	}
	window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

	const j = document.createElement('script');
	j.async = false;
	j.src = 'https://www.googletagmanager.com/gtm.js?id=' + id;
	document.head.appendChild(j);

	if (cookieYesId) {
		const k = document.createElement('script');
		k.async = false;
		k.src = `https://cdn-cookieyes.com/client_data/${cookieYesId}/script.js`;
		document.head.appendChild(k);
	}

	setHasMountedGTM(true);
}

export function insertCookieYes(id: string) {
	const k = document.createElement('script');
	k.async = false;
	k.src = `https://cdn-cookieyes.com/client_data/${id}/script.js`;
	document.head.appendChild(k);
}

declare global {
	interface Window {
		dataLayer: Array<unknown>;
	}
}
